import { render, staticRenderFns } from "./AnimeListBlock.vue?vue&type=template&id=29675c22&scoped=true&"
import script from "./AnimeListBlock.vue?vue&type=script&lang=js&"
export * from "./AnimeListBlock.vue?vue&type=script&lang=js&"
import style0 from "./AnimeListBlock.vue?vue&type=style&index=0&id=29675c22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29675c22",
  null
  
)

export default component.exports